import { METHOD } from 'services/method'

export const API_CLAIM_PRODUCT = {
    DETAIL: {
        api: '/v1/dashboard-admin/main-page/home-page/claim',
        method: METHOD.GET,
    },
    URL_IMAGE_ICON: {
        api: '/v1/dashboard-admin/main-page/home-page/claim/storage-url/attachment',
        method: METHOD.POST,
    },
    UPDATE: {
        api: '/v1/dashboard-admin/main-page/home-page/claim',
        method: METHOD.PUT,
    },
}
